import { httpClient } from '../../../httpClient';

import { IData } from '../../../models';
import { ILoginForm, ILoginFormResponse } from './models';

export const handleLogin = (form: ILoginForm): Promise<IData<ILoginFormResponse>> => {
    const formData = new FormData();

    Object.entries(form).forEach(([key, value]) => {
        formData.set(key, value);
    });

    return httpClient.post<IData<ILoginFormResponse>, FormData>('auth', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
